var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-container",class:{ 'min-container': !_vm.getTabs }},[_c('stepperGeneric',{attrs:{"steps":_vm.steps},on:{"complete":_vm.handleCompletion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }